import { apiAction } from "../models/requests";

const appendTokenName = (data) => {
    return data;
};

export function getManagers(){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    appendTokenName(data);
    return apiAction({
        types: ["GET_MANAGERS_REQUESTED", "GET_MANAGERS_SUCCESS", "GET_MANAGERS_FAILED"],
        method: "POST",
        path: "admin/get_managers",
        body: data
    });
}

export function setManagerPageInfo({pageSize,pageNo}){
    return {
        type : 'SET_MANAGER_PAGEINFO',
        payload : {pageSize,pageNo }
    }
}

export function deleteManager(manager_id){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.focus = true;
    data.target_manager = {"manager_id": manager_id};
    appendTokenName(data);
    return apiAction({
        types: ["DELETE_MANAGERS_REQUESTED", "DELETE_MANAGERS_SUCCESS", "DELETE_MANAGERS_FAILED"],
        method: "POST",
        path: "admin/delete_manager",
        body: data
    });
}


// WEBPACK FOOTER //
// ./src/actions/actionManager.js